export default __webpack_public_path__ + "static/media/iconmonstr-navigation-1.448304e5.svg";